import { gql } from '@apollo/client';

/**
 * The carrier's row in the org's onboarding view, with its "No External Integrations Required" flag. A carrier with no
 * row isn't the org's to open.
 */
export const GET_ORG_CARRIER_RELATIONSHIP = gql`
    query GetOrgCarrierRelationship($organization_id: uuid!, $carrier_id: uuid!) {
        organization_carrier_statuses(
            where: { organization_id: { _eq: $organization_id }, carrier_id: { _eq: $carrier_id } }
        ) {
            organization_id
            carrier_id
            relationship
            integrations_required
        }
    }
`;
